import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-svgbarco',
  templateUrl: './svgbarco.component.html',
  styleUrls: ['./svgbarco.component.css']
})
export class SvgbarcoComponent implements OnInit {
   @Input() color: string;

  
 

  constructor() { }

  ngOnInit() {
    
  }

}
